import classNames from 'classnames'
import React from 'react'
import Slider from 'react-slick'

import { Translation } from 'cng-common/features/translations/components/translation'
import { getCloudinaryUrl } from 'core/classes/helpers'
import { calculateFileLink } from 'core/classes/helpers/saveFiles'

import styles from './POSImages.module.scss'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

interface IProps {
  className?: string
  noData: any
  images: any
}

const POSImages = (props: IProps) => {
  const { images, noData, className } = props
  const sliderSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  const [gallery, setGallery] = React.useState(images)

  React.useEffect(() => setGallery(images), [images])
  if (noData || !gallery || !gallery.length || gallery.length < 1) {
    return (
      <div className={styles.slide}>
        <Translation text={'partner-preview-empty'} />
      </div>
    )
  }

  const result: any = []
  for (let i = 0; i < gallery.length; i++) {
    result.push(
      <div className={styles.slide} key={`pos_img_${i}`}>
        <img
          className={styles['slide__img']}
          src={getCloudinaryUrl({
            src:
              calculateFileLink({
                formId: 504,
                entryId: gallery[i].EntryId,
                fieldName: 'Image',
                fileName: gallery[i].Image || '',
                UID: gallery[i].UID,
              }) || '',
            width: 320,
            height: 240,
          })}
          alt="POS Image"
        />
      </div>
    )
  }
  return (
    <div className={classNames(styles.root, className || '')}>
      <Slider className={styles.slider} {...sliderSettings}>
        {result}
      </Slider>
    </div>
  )
}

export default POSImages
